/**
 * Random Background Image Changer for Alpine.js
 *
 * Configure the imageFolder and images array, then import into your Alpine setup.
 */
import bgs from '../data/bgs.json';

export function rbg() {
  return {
    bgFolder: '/img/rbgs/',
    bgs: bgs,
    currentBg: '',
    nextBg: '',
    start: 0,

    init() {
      this.changeBg();

      setInterval(() => {
        this.changeBg();
      }, 12000);

      // document.addEventListener('click', () => {
      //   this.changeBg();
      // });
    },

    changeBg() {
      if (this.start === 0) {
        const randomIndex = Math.floor(Math.random() * this.bgs.length);
        this.currentBg = 'https://ik.imagekit.io/annezedbee/' + this.bgs[randomIndex];
        document.body.style.backgroundImage = `linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 90%, rgba(255, 255, 255, 1) 100%), url('${this.currentBg}.jpg')`;
        this.loadNextBg();
        this.start = 1;
      } else {
        this.currentBg = this.nextBg;
        document.body.style.backgroundImage = `linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 90%, rgba(255, 255, 255, 1) 100%), url('${this.currentBg}.jpg')`;
        this.loadNextBg();
      }
    },

    loadNextBg() {
      const nextRandomIndex = Math.floor(Math.random() * this.bgs.length);
      this.nextBg = 'https://ik.imagekit.io/annezedbee/' + this.bgs[nextRandomIndex];
      document.querySelector('.hidden-bg').src = this.nextBg + '.jpg';
    },
  };
}
